export default {
    URL_TOKEN: '/Token',
    URL_PERFIL: '/Cuenta/perfil',
}